export enum ACKTypeEnum {
  'Standard' = 1,
  'Special Order Approval With Acknowledgement' = 2,
  'ASAP Acknowledgement' = 3,
  'ASAP Acknowledgement approval required' = 4,
  'Quote' = 5,
  'Special Order Approval' = 10,
}
